import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { RootState } from "../index";
import {
  fetchSubscription,
  fetchSubscriptions,
} from "../../actions/callrecorder/subscriptionsActions";

export interface SubscriptionInterface {
  url: string;

  id: number;
  user_id: number;
  type_id: number | null;
  productid: string;
  receipt: string;
  expired_at: string;
  active: boolean;

  created_at: string;
  updated_at: string;
}

export interface initialInterface {
  error: string | null;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  count: number;
}

const initialState: initialInterface = {
  error: null,
  status: 'idle',
  count: 0,
};

const adaptor = createEntityAdapter<SubscriptionInterface>();

const slice = createSlice({
  name: 'subscriptions',
  initialState: adaptor.getInitialState(initialState),
  reducers: {},
  extraReducers: (builder) => {
    builder
      // #index
      .addCase(fetchSubscriptions.pending, (state, _action) => {
        state.status = 'loading'
      })
      .addCase(fetchSubscriptions.fulfilled, (state, action) => {
        state.count = action.payload.count;
        state.entities = action.payload.subscriptions;
        state.ids = action.payload.ids;
        state.status = 'succeeded';
      })
      .addCase(fetchSubscriptions.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || 'Unknown Error';
      })

      // #show
      .addCase(fetchSubscription.fulfilled, (state, action) => {
        const subscription = Object.values(action.payload.subscription)[0];
        state.entities[subscription.id] = subscription;
      })
  }
});

const reducer = slice.reducer;
export default reducer;

export const {
  selectById: selectSubscriptionById,
  selectIds: selectSubscriptionIds,
  selectEntities: selectSubscriptionEntities,
} = adaptor.getSelectors<RootState>(state => state.callrecorder.subscriptions);
